module.exports = __webpack_public_path__ + "static/media/PROP.b666439d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/PROP.jpg
// module id = 1774
// module chunks = 1